module.exports = __webpack_public_path__ + "img/5_51.6d2d852d.png";